import { FC, useCallback } from 'react';
import { observer } from 'mobx-react';

import { Store } from '../../../stores';
import { TimerRoot } from './Timer.Root';
import { Button } from '../../../../common/ui';

export const TimerFC: FC = () => {
  const store = Store.use();

  const resendCode = useCallback(() => {
    store.resendCode();
  }, [store]);

  return store.countdown ? (
    <TimerRoot>
      Отправить код ещё раз можно через {store.countdown} секунд
    </TimerRoot>
  ) : (
    <TimerRoot>
      <Button type="button" onClick={resendCode} variant="plain">
        Отправить код заново
      </Button>
    </TimerRoot>
  );
};

export const Timer = observer(TimerFC);
